<template>
  <div class="chart" ref="line"></div>
</template>

<script>
import * as echarts from "echarts";
export default {
  data() {
    return {
      widthPix: 1,
    };
  },
  props: {
    showLegend: {
      default: true,
    },
    yName: {
      default: "单位：人",
    },
  },
  methods: {
    initChart(series, category) {
      let myChart = null;
      if (myChart != null && myChart != "" && myChart != undefined) {
        myChart.dispose();
      }
      var chartDom = this.$refs.line;
      myChart = echarts.init(chartDom);
      var option;
      option = {
        legend: {
          show: this.showLegend,
          right: 0 * this.widthPix,
          top: 8 * this.widthPix,
          bottom:0 * this.widthPix,
          itemWidth: 12 * this.widthPix,
          itemHeight: 2 * this.widthPix,
          itemGap:30 * this.widthPix,
          textStyle: {
            color: "#BDCDE4",
            fontSize: 12 * this.widthPix,
          },
        },
        xAxis: {
          type: "category",
          data: category,
          axisTick: {
            show: false,
          },

          axisLabel: {
            color: "#FFFFFF",
            fontSize: 12 * this.widthPix,
            // rotate: -50,
            interval: 0,
            lineHeight:20 * this.widthPix,
            formatter:(value)=>{
              if(value.indexOf('A区')!=-1){
                return value+'\n'+'(岚园)'
              }else if(value.indexOf('B区')!=-1){
                return value+'\n'+'(泓园)'
              }else{
                return value
              }
            }
          },
          axisLine: {
            lineStyle: {
              show: true,
              color: "#3C5787",
              width:1
            },
          },
        },

        yAxis: {
          type: "value",
          name: this.yName,
          nameGap: 20,
          nameTextStyle: {
            color: "#AEC3DC",
            fontSize: 12,
          },
          // max:100,
          splitLine: {
            lineStyle: {
              type: "dashed",
              color: "rgba(178, 194, 211, 0.2)",
            },
          },
          axisLabel: {
            color: "#6887A5",
            fontSize: 14 * this.widthPix,
          },
        },
        grid: {
          left: 40 * this.widthPix,
          right: 0 * this.widthPix,
          top: 46 * this.widthPix,
          bottom: 28 * this.widthPix,
        },
        barWidth: 6 * this.widthPix,
        series: series,
      };
      myChart.clear();
      option && myChart.setOption(option);
    },
  },
  mounted() {
    this.widthPix = window.screen.width < 1920 ? 1 : Math.floor(window.screen.width / 1920);
    // this.initChart();
  },
};
</script>
<style lang="scss" scoped>
.chart {
  width: 100%;
  height: 100%;
}
</style>
